module.exports = __webpack_public_path__ + "svg/SourceSansPro-Bold.svg?704925c132f3f5576bfab359735d2aec";